import { Link } from "react-router-dom";
import { decodeEntities } from "@wordpress/html-entities";
import classes from "../../scss/ServiceCard.module.scss";

export default function Card({ slug, title, text, className = "" }) {
  return (
    <Link to={slug.toString()} className={`${classes.card || ""} ${className}`}>
      <h3 className={classes.card__title}>{decodeEntities(title)}</h3>
      <p className={classes.card__text}>{decodeEntities(text)}</p>
      <span className={classes.card__btn}>See more</span>
    </Link>
  );
}
